import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import FoldCard from './FoldCard';
import UnfoldCard from './UnfoldCard';

const EventCard = ({ content, timeline, showType, fold, index }) => {
    return (
        <>
            {fold ? (
                <FoldCard content={content} />
            ) : (
                <UnfoldCard content={content} timeline={timeline} showType={showType} index={index} />
            )}
        </>
    );
};

EventCard.propTypes = {
    content: PropTypes.object,
    timeline: PropTypes.object,
    showType: PropTypes.string,
    fold: PropTypes.bool,
    index: PropTypes.number,
};

export default errorBoundary(EventCard);
